"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var TestHttpService = /** @class */ (function () {
    function TestHttpService(config) {
        this.throwCloudError = false;
        this.fakeResponseJson = undefined;
        this.errorJson = undefined;
        Object.assign(this, config);
    }
    TestHttpService.prototype.retryPromise = function (promise, options) {
        console.log('Retry is not implemented in test service. Returning original Promise');
        return promise;
    };
    TestHttpService.prototype.get = function (call, options) {
        // throw cloud error
        if (this.throwCloudError) {
            var fakeError = {
                response: {
                    data: this.errorJson
                }
            };
            return rxjs_1.throwError({
                originalError: fakeError,
                mappedError: call.mapError(fakeError)
            });
        }
        // return fake response
        return rxjs_1.of({
            data: this.fakeResponseJson,
            response: undefined
        });
    };
    TestHttpService.prototype.post = function (call, options) {
        // throw cloud error
        if (this.throwCloudError) {
            var fakeError = {
                response: {
                    data: this.errorJson
                }
            };
            return rxjs_1.throwError({
                originalError: fakeError,
                mappedError: call.mapError(fakeError)
            });
        }
        // return fake response
        return rxjs_1.of({
            data: this.fakeResponseJson,
            response: undefined
        });
    };
    TestHttpService.prototype.put = function (call, options) {
        // throw cloud error
        if (this.throwCloudError) {
            var fakeError = {
                response: {
                    data: this.errorJson
                }
            };
            return rxjs_1.throwError({
                originalError: fakeError,
                mappedError: call.mapError(fakeError)
            });
        }
        // return fake response
        return rxjs_1.of({
            data: this.fakeResponseJson,
            response: undefined
        });
    };
    TestHttpService.prototype.delete = function (call, options) {
        // throw cloud error
        if (this.throwCloudError) {
            var fakeError = {
                response: {
                    data: this.errorJson
                }
            };
            return rxjs_1.throwError({
                originalError: fakeError,
                mappedError: call.mapError(fakeError)
            });
        }
        // return fake response
        return rxjs_1.of({
            data: this.fakeResponseJson,
            response: undefined
        });
    };
    return TestHttpService;
}());
exports.TestHttpService = TestHttpService;
//# sourceMappingURL=test-http.service.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-core/_commonjs/http/test-http.service.js